<div class="contains-button">
  <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
    [id_parent_choose]="objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object">
  </app-position-out-config>

  <app-width-height-config [device]="device" [elementChoosing]="objectChoosing" [width]="width" [height]="height"
    (changeWidthHeight)="changeWidthHeight($event)">
  </app-width-height-config>

  <ul nz-menu nzMode="inline">
    <!-- Hiển thị -->
    <li nz-submenu nzTitle="{{ 'hien_thi' | translate }}" [(nzOpen)]="openMap.menu1"
      (nzOpenChange)="openHandler('menu1')">
      <div class="button-size" *ngIf="openMap.menu1">
        <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing"></app-hide-show-config>

        <div class="item-symbol" style="display: flex; align-items: center; justify-content: space-between">
          <p class="title" style="line-height: 1.5; margin: 0">{{ 'hien_tieu_de' | translate }}</p>
          <nz-switch [(ngModel)]="config.show_title" (ngModelChange)="updateConfig()"></nz-switch>
        </div>
        <div class="item-symbol" style="display: flex; align-items: center; justify-content: space-between">
          <p class="title" style="line-height: 1.5; margin: 0">{{ 'an_giao_hang_tan_noi' | translate }}</p>
          <nz-switch [(ngModel)]="config.hide_delivery" (ngModelChange)="updateConfig()"></nz-switch>
        </div>
        <div class="item-symbol" style="display: flex; align-items: center; justify-content: space-between">
          <p class="title" style="line-height: 1.5; margin: 0">{{ 'an_nhan_tai_cua_hang' | translate }}</p>
          <nz-switch [(ngModel)]="config.hide_pickup" (ngModelChange)="updateConfig()"></nz-switch>
        </div>

        <div class="slide-bar mt-2">
          <p class="m-0 title w-50">{{ 'phuong_thuc_mac_dinh' | translate }}</p>
          <nz-select [(ngModel)]="config.default_selected" (ngModelChange)="updateConfig()" style="width: 50%">
            <nz-option nzValue="delivery" nzLabel="{{ 'giao_hang_tan_noi' | translate }}"></nz-option>
            <nz-option nzValue="pickup" nzLabel="{{ 'nhan_tai_cua_hang' | translate }}"></nz-option>
          </nz-select>
        </div>
      </div>
    </li>

    <!-- Nội dung -->
    <li nz-submenu nzTitle="{{ 'noi_dung' | translate }}" [(nzOpen)]="openMap.menu2"
      (nzOpenChange)="openHandler('menu2')">
      <ng-container *ngIf="openMap.menu2">
        <div class="config-text" style="width: 100%" *ngFor="let section of sections">
          <p class="title mb-2" style="font-weight: 600; font-size: 13px">
            {{ section.title | translate }}
          </p>

          <mat-form-field style="width: 100%" *ngFor="let field of section.fields">
            <mat-label>{{ field.label | translate }}</mat-label>
            <textarea matInput
              [ngModel]="staticdata[field.model + '_' + functionService.selectedLanguageCode] | vhLanguage : staticdata[field.model] : objectChoosing.component"
              (ngModelChange)="staticdata[field.model + '_' + functionService.selectedLanguageCode] = $event"
              (blur)="updateStaticData()"></textarea>
          </mat-form-field>
        </div>
      </ng-container>
    </li>

    <!-- Bố cục & giao diện khung ngoài -->
    <li nz-submenu nzTitle="{{ 'bo_cuc_giao_dien' | translate }}" [(nzOpen)]="openMap.menu3"
      (nzOpenChange)="openHandler('menu3')">
      <ul class="submenu" nz-menu nzMode="inline" *ngIf="openMap.menu3">
        <li nz-submenu nzTitle="{{ 'bo_cuc' | translate }}" [nzOpen]="openSubMap['menu3_bo_cuc']"
          (nzOpenChange)="toggleSub('menu3_bo_cuc', menu3Keys)">
          <div class="container-font" *ngIf="openSubMap['menu3_bo_cuc']">
            <div class="slide-bar mt-2">
              <p class="m-0 title w-50">{{ 'khoang_cach' | translate }}</p>
              <nz-input-number [nzMin]="0" [nzMax]="100" style="width: 40%"
                [ngModel]="class['payment-method-selector']['gap'] | vhnumber" (nzBlur)="updateClass()"
                (ngModelChange)="class['payment-method-selector']['gap'] = $event + 'px'"></nz-input-number>
            </div>
          </div>
        </li>

        <li nz-submenu nzTitle="{{ 'khoang_dem' | translate }}" [nzOpen]="openSubMap['menu3_khoang_dem']"
          (nzOpenChange)="toggleSub('menu3_khoang_dem', menu3Keys)">
          <app-padding-config *ngIf="openSubMap['menu3_khoang_dem']" [objectChoosing]="objectChoosing" [device]="device"
            [class]="class" [classPadding]="class['payment-method-selector']"
            [paddingConfigs]="[{ type: 'top' }, { type: 'bottom' }, { type: 'left' }, { type: 'right' }]">
          </app-padding-config>
        </li>

        <li nz-submenu nzTitle="{{ 'tieu_de' | translate }}" [nzOpen]="openSubMap['menu3_tieu_de']"
          (nzOpenChange)="toggleSub('menu3_tieu_de', menu3Keys)">
          <app-text-format-config *ngIf="openSubMap['menu3_tieu_de']" [objectChoosing]="objectChoosing" [device]="device"
            [class]="class" [config]="config" [staticdata]="staticdata"
            [textContentClass]="class['title']" [textWrapperClass]="class['title']">
          </app-text-format-config>
        </li>

        <li nz-submenu nzTitle="{{ 'mau_nen' | translate }}" [nzOpen]="openSubMap['menu3_mau_nen']"
          (nzOpenChange)="toggleSub('menu3_mau_nen', menu3Keys)">
          <ng-container *ngIf="openSubMap['menu3_mau_nen']">
            <div class="container-color">
              <button id="btn-color" *ngFor="let background of backgroundColor"
                [ngStyle]="{ 'background-color': background.bgColor }"
                (click)="chooseBg(background, $event, 'payment-method-selector')" nz-tooltip></button>
            </div>
            <div class="color-pick mb-4">
              <span class="title w-50">{{ 'mau_nen' | translate }}</span>
              <input class="input-color w-50" type="button" [cpOKButton]="true"
                [(colorPicker)]="class['payment-method-selector']['background-color']"
                [style.background]="class['payment-method-selector']['background-color']"
                (colorPickerClose)="updateObject()" [cpWidth]="'230px'"
                [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength" [cpAddColorButton]="true"
                [cpAddColorButtonText]="'them_mau' | translate" [cpPresetLabel]="'bang_mau_mau' | translate"
                [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                [cpPresetColors]="themeService.themeColors"
                (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                (colorPickerOpen)="themeService.onPickerColorOpen($event)" />
            </div>
          </ng-container>
        </li>

        <li nz-submenu nzTitle="{{ 'kieu_vien' | translate }}" [nzOpen]="openSubMap['menu3_kieu_vien']"
          (nzOpenChange)="toggleSub('menu3_kieu_vien', menu3Keys)">
          <ng-container *ngIf="openSubMap['menu3_kieu_vien']">
            <app-borders-config [elementChoosing]="objectChoosing" [device]="device"
              [class]="class" [borderClass]="class['payment-method-selector']" [id_object]="objectChoosing._id">
            </app-borders-config>
            <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device"
              [class]="class" [borderRadiusClass]="class['payment-method-selector']" [id_object]="objectChoosing._id">
            </app-borders-radius-config>
          </ng-container>
        </li>
      </ul>
    </li>

    <!-- Giao hàng tận nơi -->
    <li nz-submenu nzTitle="{{ 'giao_hang_tan_noi' | translate }}" [(nzOpen)]="openMap.menu4"
      (nzOpenChange)="openHandler('menu4')">
      <ul class="submenu" nz-menu nzMode="inline" *ngIf="openMap.menu4">
        <li nz-submenu nzTitle="{{ 'dinh_dang_nhan' | translate }}" [nzOpen]="openSubMap['menu4_nhan']"
          (nzOpenChange)="toggleSub('menu4_nhan', menu4Keys)">
          <app-text-format-config *ngIf="openSubMap['menu4_nhan']" [objectChoosing]="objectChoosing" [device]="device"
            [class]="class" [config]="config" [staticdata]="staticdata"
            [textContentClass]="class['option-delivery-label']" [textWrapperClass]="class['option-delivery-label']">
          </app-text-format-config>
        </li>

        <li nz-submenu nzTitle="{{ 'dinh_dang_mo_ta' | translate }}" [nzOpen]="openSubMap['menu4_mo_ta']"
          (nzOpenChange)="toggleSub('menu4_mo_ta', menu4Keys)">
          <app-text-format-config *ngIf="openSubMap['menu4_mo_ta']" [objectChoosing]="objectChoosing" [device]="device"
            [class]="class" [config]="config" [staticdata]="staticdata"
            [textContentClass]="class['option-delivery-description']"
            [textWrapperClass]="class['option-delivery-description']">
          </app-text-format-config>
        </li>

        <li nz-submenu nzTitle="{{ 'mau_nen' | translate }}" [nzOpen]="openSubMap['menu4_mau_nen']"
          (nzOpenChange)="toggleSub('menu4_mau_nen', menu4Keys)">
          <div class="color-pick mb-4" *ngIf="openSubMap['menu4_mau_nen']">
            <span class="title w-50">{{ 'mau_nen' | translate }}</span>
            <input class="input-color w-50" type="button" [cpOKButton]="true"
              [(colorPicker)]="class['option-delivery']['background-color']"
              [style.background]="class['option-delivery']['background-color']" (colorPickerClose)="updateObject()"
              [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
              [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
              [cpPresetLabel]="'bang_mau_mau' | translate"
              [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
              [cpPresetColors]="themeService.themeColors"
              (cpPresetColorsChange)="themeService.presetColorsChange($event)"
              (colorPickerOpen)="themeService.onPickerColorOpen($event)" />
          </div>
        </li>

        <li nz-submenu nzTitle="{{ 'kieu_vien' | translate }}" [nzOpen]="openSubMap['menu4_kieu_vien']"
          (nzOpenChange)="toggleSub('menu4_kieu_vien', menu4Keys)">
          <ng-container *ngIf="openSubMap['menu4_kieu_vien']">
            <app-borders-config [elementChoosing]="objectChoosing" [device]="device"
              [class]="class" [borderClass]="class['option-delivery']" [id_object]="objectChoosing._id">
            </app-borders-config>
            <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device"
              [class]="class" [borderRadiusClass]="class['option-delivery']" [id_object]="objectChoosing._id">
            </app-borders-radius-config>
          </ng-container>
        </li>

        <li nz-submenu nzTitle="{{ 'khoang_dem' | translate }}" [nzOpen]="openSubMap['menu4_khoang_dem']"
          (nzOpenChange)="toggleSub('menu4_khoang_dem', menu4Keys)">
          <app-padding-config *ngIf="openSubMap['menu4_khoang_dem']" [objectChoosing]="objectChoosing" [device]="device"
            [class]="class" [classPadding]="class['option-delivery']"
            [paddingConfigs]="[{ type: 'top' }, { type: 'bottom' }, { type: 'left' }, { type: 'right' }]">
          </app-padding-config>
        </li>

        <!-- Biểu tượng (delivery icon) -->
        <li nz-submenu nzTitle="{{ 'bieu_tuong' | translate }}" [nzOpen]="openSubMap['menu4_bieu_tuong']"
          (nzOpenChange)="toggleSub('menu4_bieu_tuong', menu4Keys)">
          <div class="space-middle" *ngIf="openSubMap['menu4_bieu_tuong']">
            <div class="item-symbol">
              <p class="title" style="line-height: 1.5">{{ 'su_dung' | translate }}</p>
              <nz-switch [(ngModel)]="config.icon_delivery.icon_disable" (ngModelChange)="updateConfig()"></nz-switch>
            </div>
            <div class="d-flex justify-content-between mx-1">
              <mat-icon>{{ config.icon_delivery.icon_name }}</mat-icon>
              <button nz-button nzType="default" (click)="openDialogChooseIcon(config.icon_delivery)"
                style="border-radius: 5px" [disabled]="!config.icon_delivery.icon_disable">
                {{ 'thay_doi' | translate }}
              </button>
            </div>
            <div class="slide-bar mt-2" *ngIf="config.icon_delivery.icon_disable">
              <p class="m-0 title w-50">{{ 'kich_thuoc' | translate }}</p>
              <nz-input-number [nzMin]="10" [nzMax]="60" style="width: 40%"
                [ngModel]="class['option-delivery-icon']['font-size'] | vhnumber" (nzBlur)="updateClass()"
                (ngModelChange)="class['option-delivery-icon']['font-size'] = $event + 'px'"></nz-input-number>
            </div>
            <div class="color-pick mb-4" *ngIf="config.icon_delivery.icon_disable">
              <span class="title w-50">{{ 'mau_bieu_tuong' | translate }}</span>
              <input class="input-color w-50" type="button" [cpOKButton]="true"
                [(colorPicker)]="class['option-delivery-icon']['color']"
                [style.background]="class['option-delivery-icon']['color']" (colorPickerClose)="updateObject()"
                [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                [cpPresetLabel]="'bang_mau_mau' | translate"
                [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                [cpPresetColors]="themeService.themeColors"
                (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                (colorPickerOpen)="themeService.onPickerColorOpen($event)" />
            </div>
          </div>
        </li>

        <!-- Selected State Configs -->
        <li nz-submenu nzTitle="{{ 'mau_khi_chon' | translate }}" [nzOpen]="openSubMap['menu4_mau_nen_selected']"
          (nzOpenChange)="toggleSub('menu4_mau_nen_selected', menu4Keys)">
          <div class="color-pick mb-4" *ngIf="openSubMap['menu4_mau_nen_selected']">
            <span class="title w-50">{{ 'mau_nen' | translate }}</span>
            <input class="input-color w-50" type="button" [cpOKButton]="true"
              [(colorPicker)]="class['option-delivery-selected']['background-color']"
              [style.background]="class['option-delivery-selected']['background-color']"
              (colorPickerClose)="updateObject()" [cpWidth]="'230px'"
              [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength" [cpAddColorButton]="true"
              [cpAddColorButtonText]="'them_mau' | translate" [cpPresetLabel]="'bang_mau_mau' | translate"
              [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
              [cpPresetColors]="themeService.themeColors"
              (cpPresetColorsChange)="themeService.presetColorsChange($event)"
              (colorPickerOpen)="themeService.onPickerColorOpen($event)" />
          </div>
        </li>

        <li nz-submenu nzTitle="{{ 'mau_chu_khi_chon' | translate }}" [nzOpen]="openSubMap['menu4_nhan_selected']"
          (nzOpenChange)="toggleSub('menu4_nhan_selected', menu4Keys)">
          <app-text-format-config *ngIf="openSubMap['menu4_nhan_selected']" [objectChoosing]="objectChoosing"
            [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
            [textContentClass]="class['option-delivery-label-selected']"
            [textWrapperClass]="class['option-delivery-label-selected']">
          </app-text-format-config>
        </li>

        <li nz-submenu nzTitle="{{ 'kieu_vien_khi_chon' | translate }}"
          [nzOpen]="openSubMap['menu4_kieu_vien_selected']"
          (nzOpenChange)="toggleSub('menu4_kieu_vien_selected', menu4Keys)">
          <ng-container *ngIf="openSubMap['menu4_kieu_vien_selected']">
            <app-borders-config [elementChoosing]="objectChoosing" [device]="device"
              [class]="class" [borderClass]="class['option-delivery-selected']" [id_object]="objectChoosing._id">
            </app-borders-config>
            <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device"
              [class]="class" [borderRadiusClass]="class['option-delivery-selected']" [id_object]="objectChoosing._id">
            </app-borders-radius-config>
          </ng-container>
        </li>

        <!-- Biểu tượng khi chọn (delivery icon selected) -->
        <li nz-submenu nzTitle="{{ 'mau_bieu_tuong_khi_chon' | translate }}"
          [nzOpen]="openSubMap['menu4_bieu_tuong_selected']"
          (nzOpenChange)="toggleSub('menu4_bieu_tuong_selected', menu4Keys)">
          <div class="color-pick mb-4" *ngIf="openSubMap['menu4_bieu_tuong_selected']">
            <span class="title w-50">{{ 'mau_bieu_tuong' | translate }}</span>
            <input class="input-color w-50" type="button" [cpOKButton]="true"
              [(colorPicker)]="class['option-delivery-icon-selected']['color']"
              [style.background]="class['option-delivery-icon-selected']['color']" (colorPickerClose)="updateObject()"
              [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
              [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
              [cpPresetLabel]="'bang_mau_mau' | translate"
              [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
              [cpPresetColors]="themeService.themeColors"
              (cpPresetColorsChange)="themeService.presetColorsChange($event)"
              (colorPickerOpen)="themeService.onPickerColorOpen($event)" />
          </div>
        </li>
      </ul>
    </li>

    <!-- Nhận tại cửa hàng -->
    <li nz-submenu nzTitle="{{ 'nhan_tai_cua_hang' | translate }}" [(nzOpen)]="openMap.menu5"
      (nzOpenChange)="openHandler('menu5')">
      <ul class="submenu" nz-menu nzMode="inline" *ngIf="openMap.menu5">
        <li nz-submenu nzTitle="{{ 'dinh_dang_nhan' | translate }}" [nzOpen]="openSubMap['menu5_nhan']"
          (nzOpenChange)="toggleSub('menu5_nhan', menu5Keys)">
          <app-text-format-config *ngIf="openSubMap['menu5_nhan']" [objectChoosing]="objectChoosing" [device]="device"
            [class]="class" [config]="config" [staticdata]="staticdata"
            [textContentClass]="class['option-pickup-label']" [textWrapperClass]="class['option-pickup-label']">
          </app-text-format-config>
        </li>

        <li nz-submenu nzTitle="{{ 'dinh_dang_mo_ta' | translate }}" [nzOpen]="openSubMap['menu5_mo_ta']"
          (nzOpenChange)="toggleSub('menu5_mo_ta', menu5Keys)">
          <app-text-format-config *ngIf="openSubMap['menu5_mo_ta']" [objectChoosing]="objectChoosing" [device]="device"
            [class]="class" [config]="config" [staticdata]="staticdata"
            [textContentClass]="class['option-pickup-description']"
            [textWrapperClass]="class['option-pickup-description']">
          </app-text-format-config>
        </li>

        <!-- Huy hiệu (badge) -->
        <li nz-submenu nzTitle="{{ 'huy_hieu' | translate }}" [nzOpen]="openSubMap['menu5_huy_hieu']"
          (nzOpenChange)="toggleSub('menu5_huy_hieu', menu5Keys)">
          <div *ngIf="openSubMap['menu5_huy_hieu']">
            <div class="item-symbol" style="display: flex; align-items: center; justify-content: space-between">
              <p class="title" style="line-height: 1.5; margin: 0">{{ 'hien_huy_hieu' | translate }}</p>
              <nz-switch [(ngModel)]="config.pickup.show_badge" (ngModelChange)="updateConfig()"></nz-switch>
            </div>
            <div class="color-pick mb-4" *ngIf="config.pickup.show_badge">
              <span class="title w-50">{{ 'mau_nen_huy_hieu' | translate }}</span>
              <input class="input-color w-50" type="button" [cpOKButton]="true"
                [(colorPicker)]="class['option-pickup-badge']['background-color']"
                [style.background]="class['option-pickup-badge']['background-color']"
                (colorPickerClose)="updateObject()" [cpWidth]="'230px'"
                [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength" [cpAddColorButton]="true"
                [cpAddColorButtonText]="'them_mau' | translate" [cpPresetLabel]="'bang_mau_mau' | translate"
                [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                [cpPresetColors]="themeService.themeColors"
                (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                (colorPickerOpen)="themeService.onPickerColorOpen($event)" />
            </div>
            <div class="color-pick mb-4" *ngIf="config.pickup.show_badge">
              <span class="title w-50">{{ 'mau_chu' | translate }}</span>
              <input class="input-color w-50" type="button" [cpOKButton]="true"
                [(colorPicker)]="class['option-pickup-badge']['color']"
                [style.background]="class['option-pickup-badge']['color']" (colorPickerClose)="updateObject()"
                [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                [cpPresetLabel]="'bang_mau_mau' | translate"
                [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                [cpPresetColors]="themeService.themeColors"
                (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                (colorPickerOpen)="themeService.onPickerColorOpen($event)" />
            </div>
            <div class="slide-bar mt-2" *ngIf="config.pickup.show_badge">
              <p class="m-0 title w-50">{{ 'kich_thuoc_chu' | translate }}</p>
              <nz-input-number [nzMin]="8" [nzMax]="24" style="width: 40%"
                [ngModel]="class['option-pickup-badge']['font-size'] | vhnumber" (nzBlur)="updateClass()"
                (ngModelChange)="class['option-pickup-badge']['font-size'] = $event + 'px'"></nz-input-number>
            </div>
            <app-padding-config *ngIf="config.pickup.show_badge" [objectChoosing]="objectChoosing" [device]="device"
              [class]="class" [classPadding]="class['option-pickup-badge']"
              [paddingConfigs]="[{ type: 'top' }, { type: 'bottom' }, { type: 'left' }, { type: 'right' }]">
            </app-padding-config>
            <app-borders-radius-config *ngIf="config.pickup.show_badge" [elementChoosing]="objectChoosing"
              [device]="device" [class]="class" [borderRadiusClass]="class['option-pickup-badge']"
              [id_object]="objectChoosing._id">
            </app-borders-radius-config>
          </div>
        </li>

        <li nz-submenu nzTitle="{{ 'mau_nen' | translate }}" [nzOpen]="openSubMap['menu5_mau_nen']"
          (nzOpenChange)="toggleSub('menu5_mau_nen', menu5Keys)">
          <div class="color-pick mb-4" *ngIf="openSubMap['menu5_mau_nen']">
            <span class="title w-50">{{ 'mau_nen' | translate }}</span>
            <input class="input-color w-50" type="button" [cpOKButton]="true"
              [(colorPicker)]="class['option-pickup']['background-color']"
              [style.background]="class['option-pickup']['background-color']" (colorPickerClose)="updateObject()"
              [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
              [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
              [cpPresetLabel]="'bang_mau_mau' | translate"
              [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
              [cpPresetColors]="themeService.themeColors"
              (cpPresetColorsChange)="themeService.presetColorsChange($event)"
              (colorPickerOpen)="themeService.onPickerColorOpen($event)" />
          </div>
        </li>

        <li nz-submenu nzTitle="{{ 'kieu_vien' | translate }}" [nzOpen]="openSubMap['menu5_kieu_vien']"
          (nzOpenChange)="toggleSub('menu5_kieu_vien', menu5Keys)">
          <ng-container *ngIf="openSubMap['menu5_kieu_vien']">
            <app-borders-config [elementChoosing]="objectChoosing" [device]="device"
              [class]="class" [borderClass]="class['option-pickup']" [id_object]="objectChoosing._id">
            </app-borders-config>
            <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device"
              [class]="class" [borderRadiusClass]="class['option-pickup']" [id_object]="objectChoosing._id">
            </app-borders-radius-config>
          </ng-container>
        </li>

        <li nz-submenu nzTitle="{{ 'khoang_dem' | translate }}" [nzOpen]="openSubMap['menu5_khoang_dem']"
          (nzOpenChange)="toggleSub('menu5_khoang_dem', menu5Keys)">
          <app-padding-config *ngIf="openSubMap['menu5_khoang_dem']" [objectChoosing]="objectChoosing" [device]="device"
            [class]="class" [classPadding]="class['option-pickup']"
            [paddingConfigs]="[{ type: 'top' }, { type: 'bottom' }, { type: 'left' }, { type: 'right' }]">
          </app-padding-config>
        </li>

        <!-- Biểu tượng (pickup icon) -->
        <li nz-submenu nzTitle="{{ 'bieu_tuong' | translate }}" [nzOpen]="openSubMap['menu5_bieu_tuong']"
          (nzOpenChange)="toggleSub('menu5_bieu_tuong', menu5Keys)">
          <div class="space-middle" *ngIf="openSubMap['menu5_bieu_tuong']">
            <div class="item-symbol">
              <p class="title" style="line-height: 1.5">{{ 'su_dung' | translate }}</p>
              <nz-switch [(ngModel)]="config.icon_pickup.icon_disable" (ngModelChange)="updateConfig()"></nz-switch>
            </div>
            <div class="d-flex justify-content-between mx-1">
              <mat-icon>{{ config.icon_pickup.icon_name }}</mat-icon>
              <button nz-button nzType="default" (click)="openDialogChooseIcon(config.icon_pickup)"
                style="border-radius: 5px" [disabled]="!config.icon_pickup.icon_disable">
                {{ 'thay_doi' | translate }}
              </button>
            </div>
            <div class="slide-bar mt-2" *ngIf="config.icon_pickup.icon_disable">
              <p class="m-0 title w-50">{{ 'kich_thuoc' | translate }}</p>
              <nz-input-number [nzMin]="10" [nzMax]="60" style="width: 40%"
                [ngModel]="class['option-pickup-icon']['font-size'] | vhnumber" (nzBlur)="updateClass()"
                (ngModelChange)="class['option-pickup-icon']['font-size'] = $event + 'px'"></nz-input-number>
            </div>
            <div class="color-pick mb-4" *ngIf="config.icon_pickup.icon_disable">
              <span class="title w-50">{{ 'mau_bieu_tuong' | translate }}</span>
              <input class="input-color w-50" type="button" [cpOKButton]="true"
                [(colorPicker)]="class['option-pickup-icon']['color']"
                [style.background]="class['option-pickup-icon']['color']" (colorPickerClose)="updateObject()"
                [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                [cpPresetLabel]="'bang_mau_mau' | translate"
                [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                [cpPresetColors]="themeService.themeColors"
                (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                (colorPickerOpen)="themeService.onPickerColorOpen($event)" />
            </div>
          </div>
        </li>

        <!-- Trạng thái còn hàng -->
        <li nz-submenu nzTitle="{{ 'trang_thai_con_hang' | translate }}" [nzOpen]="openSubMap['menu5_trang_thai']"
          (nzOpenChange)="toggleSub('menu5_trang_thai', menu5Keys)">
          <div *ngIf="openSubMap['menu5_trang_thai']">
            <div class="item-symbol" style="display: flex; align-items: center; justify-content: space-between">
              <p class="title" style="line-height: 1.5; margin: 0">{{ 'hien_trang_thai' | translate }}</p>
              <nz-switch [(ngModel)]="config.pickup.show_status" (ngModelChange)="updateConfig()"></nz-switch>
            </div>
            <ng-container *ngIf="config.pickup.show_status">
              <p class="title mt-2 mb-1" style="font-weight: 600; font-size: 13px">
                {{ 'dinh_dang_tieu_de_trang_thai' | translate }}
              </p>
              <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                [config]="config" [staticdata]="staticdata" [textContentClass]="class['pickup-status-title']"
                [textWrapperClass]="class['pickup-status-title']">
              </app-text-format-config>

              <p class="title mt-2 mb-1" style="font-weight: 600; font-size: 13px">
                {{ 'dinh_dang_mo_ta_trang_thai' | translate }}
              </p>
              <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                [config]="config" [staticdata]="staticdata" [textContentClass]="class['pickup-status-subtitle']"
                [textWrapperClass]="class['pickup-status-subtitle']">
              </app-text-format-config>

              <!-- OUT OF STOCK FORMATTING -->
              <p class="title mt-3 mb-1" style="font-weight: 600; font-size: 13px; color: #dc2626">
                {{ 'dinh_dang_tieu_de_trang_thai_het_hang' | translate }}
              </p>
              <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                [config]="config" [staticdata]="staticdata" [textContentClass]="class['pickup-status-title-out']"
                [textWrapperClass]="class['pickup-status-title-out']">
              </app-text-format-config>

              <p class="title mt-2 mb-1" style="font-weight: 600; font-size: 13px; color: #dc2626">
                {{ 'dinh_dang_mo_ta_trang_thai_het_hang' | translate }}
              </p>
              <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                [config]="config" [staticdata]="staticdata" [textContentClass]="class['pickup-status-subtitle-out']"
                [textWrapperClass]="class['pickup-status-subtitle-out']">
              </app-text-format-config>
            </ng-container>
          </div>
        </li>

        <!-- Nút hành động (kiểm tra tồn kho) -->
        <li nz-submenu nzTitle="{{ 'nut_hanh_dong' | translate }}" [nzOpen]="openSubMap['menu5_nut_hanh_dong']"
          (nzOpenChange)="toggleSub('menu5_nut_hanh_dong', menu5Keys)">
          <div *ngIf="openSubMap['menu5_nut_hanh_dong']">
            <div class="item-symbol" style="display: flex; align-items: center; justify-content: space-between">
              <p class="title" style="line-height: 1.5; margin: 0">{{ 'hien_nut_hanh_dong' | translate }}</p>
              <nz-switch [(ngModel)]="config.pickup.show_action_button" (ngModelChange)="updateConfig()"></nz-switch>
            </div>
            <ng-container *ngIf="config.pickup.show_action_button">
              <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                [classPadding]="class['pickup-action-button']"
                [paddingConfigs]="[{ type: 'top' }, { type: 'bottom' }, { type: 'left' }, { type: 'right' }]">
              </app-padding-config>
              <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                [borderClass]="class['pickup-action-button']" [id_object]="objectChoosing._id">
              </app-borders-config>
              <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                [borderRadiusClass]="class['pickup-action-button']" [id_object]="objectChoosing._id">
              </app-borders-radius-config>

              <div class="color-pick mb-4">
                <span class="title w-50">{{ 'mau_nen_nut' | translate }}</span>
                <input class="input-color w-50" type="button" [cpOKButton]="true"
                  [(colorPicker)]="class['pickup-action-button']['background-color']"
                  [style.background]="class['pickup-action-button']['background-color']"
                  (colorPickerClose)="updateObject()" [cpWidth]="'230px'"
                  [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength" [cpAddColorButton]="true"
                  [cpAddColorButtonText]="'them_mau' | translate" [cpPresetLabel]="'bang_mau_mau' | translate"
                  [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                  [cpPresetColors]="themeService.themeColors"
                  (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                  (colorPickerOpen)="themeService.onPickerColorOpen($event)" />
              </div>

              <p class="title mt-2 mb-1" style="font-weight: 600; font-size: 13px">
                {{ 'dinh_dang_nhan_nut' | translate }}
              </p>
              <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                [config]="config" [staticdata]="staticdata" [textContentClass]="class['pickup-action-button-label']"
                [textWrapperClass]="class['pickup-action-button-label']">
              </app-text-format-config>

              <div class="item-symbol">
                <p class="title" style="line-height: 1.5">{{ 'hien_mui_ten' | translate }}</p>
                <nz-switch [(ngModel)]="config.icon_action_button.icon_disable"
                  (ngModelChange)="updateConfig()"></nz-switch>
              </div>
              <div class="slide-bar mt-2" *ngIf="config.icon_action_button.icon_disable">
                <p class="m-0 title w-50">{{ 'kich_thuoc_bieu_tuong' | translate }}</p>
                <nz-input-number [nzMin]="10" [nzMax]="32" style="width: 40%"
                  [ngModel]="class['pickup-action-button-icon']['font-size'] | vhnumber" (nzBlur)="updateClass()"
                  (ngModelChange)="class['pickup-action-button-icon']['font-size'] = $event + 'px'"></nz-input-number>
              </div>
              <div class="color-pick mb-4" *ngIf="config.icon_action_button.icon_disable">
                <span class="title w-50">{{ 'mau_bieu_tuong' | translate }}</span>
                <input class="input-color w-50" type="button" [cpOKButton]="true"
                  [(colorPicker)]="class['pickup-action-button-icon']['color']"
                  [style.background]="class['pickup-action-button-icon']['color']" (colorPickerClose)="updateObject()"
                  [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                  [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                  [cpPresetLabel]="'bang_mau_mau' | translate"
                  [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                  [cpPresetColors]="themeService.themeColors"
                  (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                  (colorPickerOpen)="themeService.onPickerColorOpen($event)" />
              </div>
            </ng-container>
          </div>
        </li>

        <!-- Khối thông tin cửa hàng -->
        <li nz-submenu nzTitle="{{ 'khoi_thong_tin' | translate }}" [nzOpen]="openSubMap['menu5_thong_tin']"
          (nzOpenChange)="toggleSub('menu5_thong_tin', menu5Keys)">
          <div *ngIf="openSubMap['menu5_thong_tin']">
            <div class="item-symbol" style="display: flex; align-items: center; justify-content: space-between">
              <p class="title" style="line-height: 1.5; margin: 0">{{ 'hien_khoi_thong_tin' | translate }}</p>
              <nz-switch [(ngModel)]="config.pickup.show_info_block" (ngModelChange)="updateConfig()"></nz-switch>
            </div>
            <ng-container *ngIf="config.pickup.show_info_block">
              <p class="title mt-2 mb-1" style="font-weight: 600; font-size: 13px">
                {{ 'tieu_de_khoi_thong_tin' | translate }}
              </p>
              <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                [config]="config" [staticdata]="staticdata" [textContentClass]="class['pickup-info-title']"
                [textWrapperClass]="class['pickup-info-title']">
              </app-text-format-config>

              <p class="title mt-2 mb-1" style="font-weight: 600; font-size: 13px">
                {{ 'dong_thong_tin' | translate }}
              </p>
              <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                [config]="config" [staticdata]="staticdata" [textContentClass]="class['pickup-info-row']"
                [textWrapperClass]="class['pickup-info-row']">
              </app-text-format-config>
            </ng-container>
          </div>
        </li>

        <!-- Selected State Configs -->
        <li nz-submenu nzTitle="{{ 'mau_khi_chon' | translate }}" [nzOpen]="openSubMap['menu5_mau_nen_selected']"
          (nzOpenChange)="toggleSub('menu5_mau_nen_selected', menu5Keys)">
          <div class="color-pick mb-4" *ngIf="openSubMap['menu5_mau_nen_selected']">
            <span class="title w-50">{{ 'mau_nen' | translate }}</span>
            <input class="input-color w-50" type="button" [cpOKButton]="true"
              [(colorPicker)]="class['option-pickup-selected']['background-color']"
              [style.background]="class['option-pickup-selected']['background-color']"
              (colorPickerClose)="updateObject()" [cpWidth]="'230px'"
              [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength" [cpAddColorButton]="true"
              [cpAddColorButtonText]="'them_mau' | translate" [cpPresetLabel]="'bang_mau_mau' | translate"
              [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
              [cpPresetColors]="themeService.themeColors"
              (cpPresetColorsChange)="themeService.presetColorsChange($event)"
              (colorPickerOpen)="themeService.onPickerColorOpen($event)" />
          </div>
        </li>

        <li nz-submenu nzTitle="{{ 'mau_chu_khi_chon' | translate }}" [nzOpen]="openSubMap['menu5_nhan_selected']"
          (nzOpenChange)="toggleSub('menu5_nhan_selected', menu5Keys)">
          <app-text-format-config *ngIf="openSubMap['menu5_nhan_selected']" [objectChoosing]="objectChoosing"
            [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
            [textContentClass]="class['option-pickup-label-selected']"
            [textWrapperClass]="class['option-pickup-label-selected']">
          </app-text-format-config>
        </li>

        <li nz-submenu nzTitle="{{ 'kieu_vien_khi_chon' | translate }}"
          [nzOpen]="openSubMap['menu5_kieu_vien_selected']"
          (nzOpenChange)="toggleSub('menu5_kieu_vien_selected', menu5Keys)">
          <ng-container *ngIf="openSubMap['menu5_kieu_vien_selected']">
            <app-borders-config [elementChoosing]="objectChoosing" [device]="device"
              [class]="class" [borderClass]="class['option-pickup-selected']" [id_object]="objectChoosing._id">
            </app-borders-config>
            <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device"
              [class]="class" [borderRadiusClass]="class['option-pickup-selected']" [id_object]="objectChoosing._id">
            </app-borders-radius-config>
          </ng-container>
        </li>

        <!-- Biểu tượng khi chọn (pickup icon selected) -->
        <li nz-submenu nzTitle="{{ 'mau_bieu_tuong_khi_chon' | translate }}"
          [nzOpen]="openSubMap['menu5_bieu_tuong_selected']"
          (nzOpenChange)="toggleSub('menu5_bieu_tuong_selected', menu5Keys)">
          <div class="color-pick mb-4" *ngIf="openSubMap['menu5_bieu_tuong_selected']">
            <span class="title w-50">{{ 'mau_bieu_tuong' | translate }}</span>
            <input class="input-color w-50" type="button" [cpOKButton]="true"
              [(colorPicker)]="class['option-pickup-icon-selected']['color']"
              [style.background]="class['option-pickup-icon-selected']['color']" (colorPickerClose)="updateObject()"
              [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
              [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
              [cpPresetLabel]="'bang_mau_mau' | translate"
              [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
              [cpPresetColors]="themeService.themeColors"
              (cpPresetColorsChange)="themeService.presetColorsChange($event)"
              (colorPickerOpen)="themeService.onPickerColorOpen($event)" />
          </div>
        </li>
      </ul>
    </li>

    <!-- Hộp thoại kiểm tra tồn kho -->
    <li nz-submenu nzTitle="{{ 'hop_thoai_kiem_tra_ton_kho' | translate }}" [(nzOpen)]="openMap.menu6"
      (nzOpenChange)="openHandler('menu6')">
      <ul class="submenu" nz-menu nzMode="inline" *ngIf="openMap.menu6">
        <li nz-submenu nzTitle="{{ 'hop_thoai' | translate }}" [nzOpen]="openSubMap['menu6_hop_thoai']"
          (nzOpenChange)="toggleSub('menu6_hop_thoai', menu6Keys)">
          <div *ngIf="openSubMap['menu6_hop_thoai']">
            <div class="item-symbol" style="display: flex; align-items: center; justify-content: space-between">
              <p class="title" style="line-height: 1.5; margin: 0">{{ 'cho_phep_mo_hop_thoai' | translate }}</p>
              <nz-switch [(ngModel)]="config.pickup.show_modal" (ngModelChange)="updateConfig()"></nz-switch>
            </div>
            <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
              [borderClass]="class['modal-box']" [id_object]="objectChoosing._id">
            </app-borders-config>
            <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
              [borderRadiusClass]="class['modal-box']" [id_object]="objectChoosing._id">
            </app-borders-radius-config>
            <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
              [classPadding]="class['modal-box']"
              [paddingConfigs]="[{ type: 'top' }, { type: 'bottom' }, { type: 'left' }, { type: 'right' }]">
            </app-padding-config>
            <div class="color-pick mb-4">
              <span class="title w-50">{{ 'mau_nen' | translate }}</span>
              <input class="input-color w-50" type="button" [cpOKButton]="true"
                [(colorPicker)]="class['modal-box']['background-color']"
                [style.background]="class['modal-box']['background-color']" (colorPickerClose)="updateObject()"
                [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                [cpPresetLabel]="'bang_mau_mau' | translate"
                [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                [cpPresetColors]="themeService.themeColors"
                (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                (colorPickerOpen)="themeService.onPickerColorOpen($event)" />
            </div>
          </div>
        </li>

        <li nz-submenu nzTitle="{{ 'tieu_de_hop_thoai' | translate }}" [nzOpen]="openSubMap['menu6_tieu_de']"
          (nzOpenChange)="toggleSub('menu6_tieu_de', menu6Keys)">
          <app-text-format-config *ngIf="openSubMap['menu6_tieu_de']" [objectChoosing]="objectChoosing"
            [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
            [textContentClass]="class['modal-header-title']" [textWrapperClass]="class['modal-header-title']">
          </app-text-format-config>
        </li>

        <li nz-submenu nzTitle="{{ 'van_ban' | translate }}" [nzOpen]="openSubMap['menu6_van_ban']"
          (nzOpenChange)="toggleSub('menu6_van_ban', menu6Keys)">
          <app-text-format-config *ngIf="openSubMap['menu6_van_ban']" [objectChoosing]="objectChoosing"
            [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
            [textContentClass]="class['modal-item-name']" [textWrapperClass]="class['modal-item-name']">
          </app-text-format-config>
        </li>

        <li nz-submenu nzTitle="{{ 'phu_de_san_pham' | translate }}" [nzOpen]="openSubMap['menu6_phu_de']"
          (nzOpenChange)="toggleSub('menu6_phu_de', menu6Keys)">
          <app-text-format-config *ngIf="openSubMap['menu6_phu_de']" [objectChoosing]="objectChoosing"
            [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
            [textContentClass]="class['modal-item-subtitle']" [textWrapperClass]="class['modal-item-subtitle']">
          </app-text-format-config>
        </li>

        <!-- ===== Nhãn CÒN HÀNG (in stock) ===== -->
        <li nz-submenu nzTitle="{{ 'nhan_ton_kho' | translate }}" [nzOpen]="openSubMap['menu6_ton_kho']"
          (nzOpenChange)="toggleSub('menu6_ton_kho', menu6Keys)">
          <div *ngIf="openSubMap['menu6_ton_kho']">
            <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
              [config]="config" [staticdata]="staticdata"
              [textContentClass]="class['modal-stock-label']"
              [textWrapperClass]="class['modal-stock-label']">
            </app-text-format-config>

            <div class="item-symbol mt-2">
              <p class="title" style="line-height: 1.5">{{ 'hien_bieu_tuong' | translate }}</p>
              <nz-switch [(ngModel)]="config.icon_in_stock.icon_disable" (ngModelChange)="updateConfig()"></nz-switch>
            </div>
            <div class="d-flex justify-content-between mx-1" *ngIf="config.icon_in_stock.icon_disable">
              <mat-icon>{{ config.icon_in_stock.icon_name }}</mat-icon>
              <button nz-button nzType="default" (click)="openDialogChooseIcon(config.icon_in_stock)"
                style="border-radius: 5px">
                {{ 'thay_doi' | translate }}
              </button>
            </div>
          </div>
        </li>

        <!-- ===== Nhãn HẾT HÀNG (out of stock) — NEW ===== -->
        <li nz-submenu nzTitle="{{ 'nhan_het_hang' | translate }}" [nzOpen]="openSubMap['menu6_ton_kho_out']"
          (nzOpenChange)="toggleSub('menu6_ton_kho_out', menu6Keys)">
          <div *ngIf="openSubMap['menu6_ton_kho_out']">
            <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
              [config]="config" [staticdata]="staticdata"
              [textContentClass]="class['modal-stock-label-out']"
              [textWrapperClass]="class['modal-stock-label-out']">
            </app-text-format-config>

            <div class="color-pick mb-4 mt-2">
              <span class="title w-50">{{ 'mau_chu' | translate }}</span>
              <input class="input-color w-50" type="button" [cpOKButton]="true"
                [(colorPicker)]="class['modal-stock-label-out']['color']"
                [style.background]="class['modal-stock-label-out']['color']"
                (colorPickerClose)="updateObject()" [cpWidth]="'230px'"
                [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                [cpPresetLabel]="'bang_mau_mau' | translate"
                [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                [cpPresetColors]="themeService.themeColors"
                (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                (colorPickerOpen)="themeService.onPickerColorOpen($event)" />
            </div>

            <div class="color-pick mb-4">
              <span class="title w-50">{{ 'mau_nen' | translate }}</span>
              <input class="input-color w-50" type="button" [cpOKButton]="true"
                [(colorPicker)]="class['modal-stock-label-out']['background-color']"
                [style.background]="class['modal-stock-label-out']['background-color']"
                (colorPickerClose)="updateObject()" [cpWidth]="'230px'"
                [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                [cpPresetLabel]="'bang_mau_mau' | translate"
                [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                [cpPresetColors]="themeService.themeColors"
                (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                (colorPickerOpen)="themeService.onPickerColorOpen($event)" />
            </div>

            <div class="item-symbol mt-2">
              <p class="title" style="line-height: 1.5">{{ 'hien_bieu_tuong' | translate }}</p>
              <nz-switch [(ngModel)]="config.icon_out_of_stock.icon_disable" (ngModelChange)="updateConfig()"></nz-switch>
            </div>
            <div class="d-flex justify-content-between mx-1" *ngIf="config.icon_out_of_stock.icon_disable">
              <mat-icon>{{ config.icon_out_of_stock.icon_name }}</mat-icon>
              <button nz-button nzType="default" (click)="openDialogChooseIcon(config.icon_out_of_stock)"
                style="border-radius: 5px">
                {{ 'thay_doi' | translate }}
              </button>
            </div>
          </div>
        </li>

        <!-- Số lượng sản phẩm (thay cho nút chính) -->
        <li nz-submenu nzTitle="{{ 'so_luong_con_lai' | translate }}" [nzOpen]="openSubMap['menu6_so_luong']"
          (nzOpenChange)="toggleSub('menu6_so_luong', menu6Keys)">
          <div *ngIf="openSubMap['menu6_so_luong']">
            <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
              [config]="config" [staticdata]="staticdata"
              [textContentClass]="class['modal-quantity']"
              [textWrapperClass]="class['modal-quantity']">
            </app-text-format-config>

            <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
              [classPadding]="class['modal-quantity']"
              [paddingConfigs]="[{ type: 'top' }, { type: 'bottom' }, { type: 'left' }, { type: 'right' }]">
            </app-padding-config>
          </div>
        </li>
      </ul>
    </li>
  </ul>
</div>